import apiClient from '../axios';

function postRewardRedemptionRedeem(data) {
  return apiClient.post('/reward-redemptions/redeem', data);
}

export { postRewardRedemptionRedeem };
